import { Component } from "@angular/core";

@Component({
  selector: "app-not-found",
  templateUrl: "./not-found.component.html",
  styleUrls: ["not-found.component.scss"],
  animations: [] //[routerTransition()]
})
export class NotFoundComponent {}



// WEBPACK FOOTER //
// ./src/app/shared/components/not-found/not-found.component.ts